/**
 * View split left and right parts, default 50% 50% relation
 *
 */
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import React from "react";
import clsx from "clsx";

const useSplitViewStyles = makeThemedStyles("SplitView", (theme) => ({
  root: {
    display: "grid",
    width: "100%",
  },
}));
const SplitView = (
  props: React.PropsWithChildren<{
    left?: string;
    right?: string;
    partCnt?: number;
    gap?: string;
    className?: string;
  }>
) => {
  const styles = useSplitViewStyles();

  if (props.partCnt) {
    const pros = 100 / props.partCnt;
    const parts: string[] = [];
    for (let i = 0; i < props.partCnt; i++) {
      parts.push(`${pros.toFixed(0)}%`);
    }
    return (
      <div
        className={clsx(styles.root, props.className || "")}
        style={{
          gridTemplateColumns: `${parts.join(" ")}`,
          display: "grid",
          gridGap: props.gap,
        }}
      >
        {props.children}
      </div>
    );
  }

  const left = props.left || "50%";
  const right = props.right || "50%";
  return (
    <div
      className={styles.root}
      style={{
        gridTemplateColumns: `${left} ${right} `,
        display: "grid",
        gridGap: props.gap,
      }}
    >
      {props.children}
    </div>
  );
};

export default SplitView;
